export default "__VITE_ASSET__5AdJCLWC__"